export default "__VITE_ASSET__DJQIKA$E__"